import { ref } from 'vue';
import axios from 'axios';

/**
 * Geteilter Lade-Layer fuer /stimmungsbarometer/getHistory.
 *
 * Der State liegt auf Modulebene, nicht in der Karte: So ueberlebt der geladene Bestand ein
 * Aus- und Wiedereinhaengen der Komponente, und parallele Aufrufe haengen sich an den laufenden
 * Request an, statt einen zweiten zu starten. Frueher lag der Vergleich zusaetzlich in einer
 * eigenen Karte, die sich denselben Bestand teilte; die Ansichten stecken jetzt alle im
 * Umschalter der Stimmungsverlaufs-Karte.
 *
 * Geladen wird weiterhin erst auf Anforderung - die Antwort enthaelt alle Saisons mit je einem
 * Punkt pro Tag und ist zu gross, um sie beim Seitenaufbau ungefragt zu ziehen.
 */

const seasons = ref([]);
const isLoading = ref(false);
const hasLoaded = ref(false);
const error = ref(null);

let pendingRequest = null;

async function load() {
  if (hasLoaded.value) return seasons.value;
  if (pendingRequest) return pendingRequest;

  isLoading.value = true;
  error.value = null;

  pendingRequest = axios
    .get(process.env.VUE_APP_BACKEND_URL + '/stimmungsbarometer/getHistory')
    .then(response => {
      seasons.value = Array.isArray(response.data) ? response.data : [];
      hasLoaded.value = true;
      return seasons.value;
    })
    .catch(err => {
      error.value = err;
      throw err;
    })
    .finally(() => {
      isLoading.value = false;
      pendingRequest = null;
    });

  return pendingRequest;
}

export function useMoodHistory() {
  return { seasons, isLoading, hasLoaded, error, load };
}
